export default {"src":"/_next/static/media/store-apple.38b5d3cb.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};